export const LevelErrorHandleFields = {
  name: 'Please input a name.',
  color: 'Please input a colour code in hex.',
  image: 'Please provide an image.',
  levelExists: 'Level already exists.',
  conditionField: 'Please input a number in each field.',
  conditionOne: 'You cannot disable this condition since it is necessary when processing downgrade in renewal.',
  noCondition: 'At least one of the conditions must be toggled on.',
  downgradeCheckConditionOne: 'You can only select this logic if all active lower levels have enabled condition 1 for entry.',
  downgradeLogic: 'Please select an option.',
  level: 'Please select a level.',
  titleAndContent: 'Please input both the title & content.',
  number: 'Please input a valid number.',
};
